import React from 'react'

const Percent3 = ({ color, size }) => {
  return (
    <svg
      width={size || '14'}
      height={size || '14'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill={color || 'white'}
          class="st0"
          d="M1.5,3.6c0-0.9,0.3-1.6,0.9-2.1c0.6-0.5,1.3-0.8,2.2-0.8c0.9,0,1.7,0.3,2.3,0.8C7.4,2,7.7,2.7,7.7,3.7v0.7
		c0,0.9-0.3,1.6-0.9,2.1C6.3,7,5.5,7.3,4.6,7.3C3.7,7.3,2.9,7,2.3,6.5C1.8,5.9,1.5,5.2,1.5,4.3V3.6z M3.4,4.4c0,0.4,0.1,0.7,0.3,1
		c0.2,0.2,0.5,0.4,0.9,0.4c0.4,0,0.7-0.1,0.9-0.4c0.2-0.2,0.3-0.6,0.3-1V3.6c0-0.4-0.1-0.7-0.3-1C5.2,2.4,4.9,2.3,4.6,2.3
		c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.3,0.6-0.3,1V4.4z M5.1,14.1l-1.4-0.7l7-11.2l1.4,0.7L5.1,14.1z M8.3,11.6
		c0-0.9,0.3-1.6,0.9-2.1c0.6-0.5,1.3-0.8,2.2-0.8c0.9,0,1.7,0.3,2.3,0.8c0.6,0.5,0.9,1.3,0.9,2.2v0.7c0,0.9-0.3,1.6-0.8,2.1
		c-0.6,0.5-1.3,0.8-2.2,0.8c-0.9,0-1.7-0.3-2.3-0.8c-0.6-0.5-0.9-1.3-0.9-2.2V11.6z M10.2,12.4c0,0.4,0.1,0.7,0.4,0.9
		c0.2,0.3,0.5,0.4,0.9,0.4c0.8,0,1.2-0.4,1.2-1.3v-0.7c0-0.4-0.1-0.7-0.3-0.9c-0.2-0.2-0.5-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4
		c-0.2,0.2-0.3,0.6-0.3,1V12.4z"
        />
      </g>
    </svg>
  )
}
export default Percent3
